var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6945FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9L9.476 10.428C9.714 11.1429 10.3834 11.625 11.1367 11.625H15.125V13.445C12.1579 13.8702 9.875 16.4148 9.875 19.5V22.125C9.875 22.608 10.267 23 10.75 23H21.25C21.733 23 22.125 22.608 22.125 22.125V19.5C22.125 16.4148 19.8421 13.8702 16.875 13.445V11.625H20.8632C21.6166 11.625 22.2851 11.1429 22.5231 10.428L23 9H9ZM17.75 18.625C17.75 19.5919 16.9669 20.375 16 20.375C15.0331 20.375 14.25 19.5919 14.25 18.625C14.25 17.6581 15.0331 16.875 16 16.875C16.9669 16.875 17.75 17.6581 17.75 18.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weight-icon.c8d6eda04de1cabb240adf7f668430df.svg";
export { ForwardRef as ReactComponent };